import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { MultiSelect } from '@/components/forms/MultiSelect'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { FormField } from '@/components/forms/FormField'
import { setFilter } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.redux'
import { fetchAgentsByOrg } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.actions'

export const AgentsDropdown = ({ disabledByTags = false, label = 'Agents' }) => {
  const dispatch = useDispatch()
  const [agentSearchQuery, setAgentSearchQuery] = useState('')
  const { organizationid: organizationId } = useSelector((state) => state.currentUser)
  const { data, filters, loading } = useSelector((state) => state.realtimeCoaching)
  const isDropdownDisabled = disabledByTags && !isEmpty(filters.tags)

  useEffect(() => {
    if (isEmpty(data.agents)) {
      dispatch(fetchAgentsByOrg(organizationId))
    }
  }, [])

  return (
    <FormField data-testid="rtc-agents-dropdown">
      <label htmlFor="rtc-filter-agents">{label}</label>
      <InteractiveTooltip
        block
        content="Agents and tags cannot be selected at the same time"
        hide={!isDropdownDisabled}
      >
        <div>
          <MultiSelect
            isSelectAll
            placeholderPill="All Agents"
            inputId="rtc-filter-agents"
            options={!agentSearchQuery && data.agents.length > 1000 ? [] : data.agents}
            optionsLength={data.agents.length}
            loading={loading.agents}
            value={filters.agents}
            onInputChange={(inputValue) => setAgentSearchQuery(inputValue)}
            onChange={(value) => dispatch(setFilter({ agents: value }))}
            noOptionsMessage={() =>
              agentSearchQuery ? 'No results found' : 'Begin typing to search...'
            }
            disabled={isDropdownDisabled}
          />
        </div>
      </InteractiveTooltip>
    </FormField>
  )
}
